import { useActions } from 'shared/hooks';
import { putAvailability, getAvailability } from 'store/survey/actions';
import { GetAvailabilityRes, SendAvailabilityData } from '../../../../api/surveys/types';
import * as React from 'react';

export const useSurveyActions = () =>
  useActions({
    putAvailability,
    getAvailability,
  });

export const useHandleSubmit = () => {
  const { putAvailability: postAction } = useSurveyActions();
  return async (
    data: SendAvailabilityData,
    showError: React.Dispatch<React.SetStateAction<boolean>>,
    finishedPosting: React.Dispatch<React.SetStateAction<boolean>>,
  ) => {
    try {
      await postAction(data);
      finishedPosting(true);
    } catch (e) {
      showError(true);
    }
  };
};

export const useAvailabilityData = () => {
  const { getAvailability: fetchAvailability } = useSurveyActions();

  return async (id: string): Promise<GetAvailabilityRes | undefined> => {
    try {
      const res = await fetchAvailability(id);
      return (res as unknown) as GetAvailabilityRes;
    } catch (e) {
      return undefined;
    }
  };
};
